module.exports = __webpack_public_path__ + "static/media/fruitcake.1e14f855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/fruitcake.jpg
// module id = 561
// module chunks = 0